import { ComponentProps } from 'react';

import Facebook from 'components/shared/Icon/icons/Facebook';
import Help from 'components/shared/Icon/icons/Help';
import Instagram from 'components/shared/Icon/icons/Instagram';
import PDF from 'components/shared/Icon/icons/PDF';
import Phone from 'components/shared/Icon/icons/Phone';
import Share from 'components/shared/Icon/icons/Share';
import Share2 from 'components/shared/Icon/icons/Share2';
import Vimeo from 'components/shared/Icon/icons/Vimeo';
import i18n from 'i18n';

import styles from './index.module.css';
import TourTooltip from './TourTooltip';

export const iconsConfig = {
  share: {
    icon: (props: ComponentProps<typeof Share2>) => <Share2 {...props} style={{ color: '3E3E40' }} />,
    className: styles.shareIcon2,
    classNamePortal: styles.shareIconPortal2,
    getHint: () => i18n.t('proposal_content.copy_link'),
  },
  invite: {
    icon: Share,
    className: styles.shareIcon,
    classNamePortal: styles.shareIconPortal,
    getHint: () => i18n.t('proposal_content.guest_portal.share.title'),
  },
  print: {
    icon: PDF,
    className: styles.printIcon,
    classNamePortal: styles.printIconPortal,
    getHint: () => i18n.t('proposal_content.file.download_as_pdf'),
  },
  phone: {
    icon: Phone,
    className: styles.phoneIcon,
    classNamePortal: styles.phoneIconPortal,
    getHint: () => i18n.t('proposal_content.contact.travel_consultant'),
  },
  help: {
    icon: Help,
    className: styles.helpIcon,
    classNamePortal: styles.helpIconPortal,
    getHint: () => 'Tool Tips',
    customElement: TourTooltip,
  },
  facebook: { icon: Facebook },
  vimeo: { icon: Vimeo },
  instagram: { icon: Instagram },
};
